import axios, { buildApi } from '@/libs/api.request';
let name = ''

export const apis = buildApi({
  get: ['/common/contractConfig&list',],
  post: [name + '/save', name + '/delete/:id&del']
})